import { PartTypeType } from "shared";

export const sortQuoteRequestLineByPartType = (
  assemblyA: {
    quoteRequestLine: { part: { name: string; type: PartTypeType | null } };
  },
  assemblyB: {
    quoteRequestLine: { part: { name: string; type: PartTypeType | null } };
  },
): number => {
  if (
    assemblyA.quoteRequestLine.part.type === "CONSUMABLE" &&
    assemblyB.quoteRequestLine.part.type !== "CONSUMABLE"
  ) {
    return 1;
  }

  if (
    assemblyA.quoteRequestLine.part.type !== "CONSUMABLE" &&
    assemblyB.quoteRequestLine.part.type === "CONSUMABLE"
  ) {
    return -1;
  }

  const nameA = assemblyA.quoteRequestLine.part.name || "";
  const nameB = assemblyB.quoteRequestLine.part.name || "";

  return nameA.localeCompare(nameB);
};
